import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Hero.css";

const Hero = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setIsVisible(true);
    const img = new Image();
    img.src = require('../assets/Team.jpg');
    img.onload = () => {
      setIsLoaded(true);
    };
  }, []);

  const handleAdmissionsClick = () => {
    navigate('/branch-and-courses#contact');
  };

  if (!isLoaded) {
    return (
      <div className="hero-skeleton">
        <div className="skeleton-content">
          <div className="skeleton-title">
            <div className="skeleton-line"></div>
            <div className="skeleton-line"></div>
            <div className="skeleton-line"></div>
          </div>
          <div className="skeleton-subtitle"></div>
          <div className="skeleton-button"></div>
        </div>
      </div>
    );
  }

  return (
    <div className={`hero ${isLoaded ? 'loaded' : 'loading'}`}>
      <div className="hero-overlay" />
      <div className="hero-content">
        <h1 className="hero-title">
          <div className="title-container">
            <span className={`title-line welcome ${isVisible ? 'slide-in-left' : ''}`}>
              WELCOME
            </span>
            <span className={`title-line to ${isVisible ? 'slide-in-right' : ''}`}>
              TO
            </span>
          </div>
          <span className={`title-line biyanis ${isVisible ? 'fade-in-up' : ''}`}>
            BIYANI'S
          </span>
        </h1>
        <p className={`hero-subtitle ${isVisible ? 'fade-in-up' : ''}`}>
          The Best Ones in ICSE and CBSE
        </p>
        <button 
          className={`admissions-button ${isVisible ? 'fade-in-up' : ''}`}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={handleAdmissionsClick}
        >
          Admissions
        </button>
      </div>
    </div>
  );
};

const styles = {
  hero: {
    height: "100vh",
    background: "url('/Team.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    alignItems: "center",
    position: "relative",
    overflow: "hidden",
  },
  content: {
    maxWidth: "1200px",
    margin: "0",
    position: "relative",
    zIndex: "2",
    background: "rgba(0, 0, 0, 0.3)",
    padding: "40px 120px",
    borderRadius: "10px",
  },
  title: {
    display: "flex",
    flexDirection: "column",
    margin: "0",
    padding: "0",
    color: "#F8F8F8",
    lineHeight: "1",
  },
  titleContainer: {
    display: "flex",
    flexDirection: "row",
    gap: "20px",
    marginBottom: "10px",
  },
  titleLine: {
    fontSize: "90px",
    fontWeight: "700",
    letterSpacing: "-2px",
    margin: "0",
    lineHeight: "1",
    transition: "color 0.3s ease-in-out",
  },
  subtitle: {
    fontSize: "20px",
    color: "#F8F8F8",
    margin: "20px 0 40px",
    letterSpacing: "2px",
    fontFamily: "'Poppins', sans-serif",
    fontWeight: "300",
  },
  button: {
    display: "none"
  },
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    zIndex: 1,
  },
};

// Add these keyframe animations at the end of the styles object
const keyframes = `
@keyframes slideInLeft {
  from {
    transform: translateX(-100px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slideInRight {
  from {
    transform: translateX(100px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes fadeInUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes zoomIn {
  from {
    transform: scale(1.1);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
`;

// Add the keyframes to the document
const styleSheet = document.createElement("style");
styleSheet.innerText = keyframes;
document.head.appendChild(styleSheet);

export default Hero;
